export const LANGUAGE = 'language';

export const BUILT_IN_VARIABLES = {
  now: '$now',
  accessToken: '$accessToken',
  userId: '$userId',
  siteId: '$siteId',
  siteGroupId: '$siteGroupId',
  siteGroupName: '$siteGroupName',
};

export const ERROR_MESSAGES = {
  contactAdmin: 'There are some errors, please contact the administrator.',
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DEFAULT_DATE_FROM_LABEL = 'Effective From';
export const DEFAULT_DATE_TO_LABEL = 'Effective To';

export const WIDGETS_TYPE = {
  widget: 'Widget',
  field: 'Field',
};

export const ENVIRONMENT_VARIABLES = {
  development: 'development',
  test: 'test',
  staging: 'staging',
  production: 'production',
};

export const LOCAL_VARIABLE_NAME_REGEX = /\$\$([{}A-Za-z.]*)/g;

export const FORM_DATA_STATUS_FIELD = '{status}';
export const FORM_DATA_STATUS_NEW = 'new';

export const TEMPLATE_NAME_NONE = 'none';
export const TEMPLATE_NAME_CRUD = 'crud';
// export const TEMPLATE_NAME_OBJECT = 'object';

// enum SiteGroupStatus
export const SITE_GROUP_STATUS_NEW = 'New';
export const SITE_GROUP_STATUS_APPROVED = 'Approved';
export const SITE_GROUP_STATUS_REJECTED = 'Rejected';
export const SITE_GROUP_STATUS_DELETED = 'Deleted';

export const DRAFT_STATUS = 'Draft';
export const PUBLISHED_STATUS = 'Published';
export const DELETED_STATUS = 'Deleted';

export const ERROR_TYPE_API = 'api';
export const ERROR_TYPE_NETWORK = 'network';
export const ERROR_TYPE_APPLICATION = 'application';

export const WARNING_TYPE_API = 'api';

export const DEFAULT_PERMISSION_PREFIX = '/UIUX';
export const TIMEOUT_PERIOD = 300;
export const AUTO_RENEW_PERIOD = 1200;

export const IRPM_EXPIRE_ERROR_CODE = 'C1012';

export const TOKEN_EXPIRE_SETTINGS = {
  exp: 2,
  unit: 'h',
};

export const ABSOLUTE_HTTP_PATH_REGEX = /(^http(s)?)/;

export const API_CALLING_TIMEOUT = 10000;
export const API_CALLING_TERMINATE = 60000;

export const ROOT_ADMIN_LINK = `${window.origin}#/root/admin/1.0.0`;

export const DIALOG_RESULT_OK = 'ok';
export const DIALOG_RESULT_CANCEL = 'cancel';
